export default __webpack_public_path__ + "static/media/T_59_mobile.779d0b2d.jpg";